import { render } from "./HorseTable.vue?vue&type=template&id=629a8ad0"
import script from "./HorseTable.vue?vue&type=script&lang=js"
export * from "./HorseTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__